import { delay } from "@utility/timerUtils";
import type { Ref } from "vue";

export const resolveQueuedRequest = async <T>(
  requestRef: Ref<T | undefined | null>,
  queueLookupMs: number = 25
): Promise<T> => {
  const queueRefLookup = async <T>() => {
    await delay(queueLookupMs);
    if (requestRef.value !== undefined && requestRef.value !== null) {
      return requestRef.value;
    } else {
      return await queueRefLookup<T>();
    }
  };

  if (requestRef.value !== undefined && requestRef.value !== null) {
    return requestRef.value;
  } else {
    return await queueRefLookup<T>();
  }
};

export const resolveQueuedRequestMap = async <K, T>(
  mapKey: K,
  map: Map<K, T>,
  queueLookupMs: number = 25
): Promise<T> => {
  const queueMapLookup = async <T>() => {
    await delay(queueLookupMs);
    const v = map.get(mapKey);
    if (v !== undefined && v !== null) {
      return v;
    } else {
      return await queueMapLookup<T>();
    }
  };

  const v = map.get(mapKey);
  if (v !== undefined && v !== null) {
    return v;
  } else {
    return await queueMapLookup<T>();
  }
};
